module.exports = __webpack_public_path__ + "images/questions/qa_human_02_e9a54a35c0e7ffddd4f0c1e4a63e9c52.png";